<template>
  <!--begin::List Widget 1-->
  <div class="row">
    <div class="col-xl-4">
      <!--begin::Stats Widget 16-->
      <router-link :to="{ name: 'Orders'}" class="card card-custom card-stretch gutter-b">
        <!--begin::Body-->
        <div class="card-body">
        <span class="svg-icon svg-icon-info svg-icon-3x ml-n1"><!--begin::Svg Icon | path:assets/media/svg/icons/Shopping/Cart3.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect x="0" y="0" width="24" height="24"/>
        <path d="M12,4.56204994 L7.76822128,9.6401844
         C7.4146572,10.0644613 6.7840925,10.1217854
          6.3598156,9.76822128 C5.9355387,9.4146572
           5.87821464,8.7840925 6.23177872,8.3598156
            L11.2317787,2.3598156 C11.6315738,1.88006147
             12.3684262,1.88006147 12.7682213,2.3598156
              L17.7682213,8.3598156 C18.1217854,8.7840925
               18.0644613,9.4146572 17.6401844,9.76822128
                C17.2159075,10.1217854 16.5853428,10.0644613
                 16.2317787,9.6401844 L12,4.56204994 Z" fill="#000000" fill-rule="nonzero" opacity="0.3"/>
        <path d="M3.5,9 L20.5,9 C21.0522847,9 21.5,9.44771525
         21.5,10 C21.5,10.132026 21.4738562,10.2627452
          21.4230769,10.3846154 L17.7692308,19.1538462
           C17.3034221,20.271787 16.2111026,21 15,21
            L9,21 C7.78889745,21 6.6965779,20.271787
             6.23076923,19.1538462 L2.57692308,10.3846154
              C2.36450587,9.87481408 2.60558331,9.28934029
               3.11538462,9.07692308 C3.23725479,9.02614384
                3.36797398,9 3.5,9 Z M12,17 C13.1045695,17
                 14,16.1045695 14,15 C14,13.8954305 13.1045695,13
                  12,13 C10.8954305,13 10,13.8954305 10,15 C10,16.1045695 10.8954305,17 12,17 Z" fill="#000000"/>
    </g>
</svg><!--end::Svg Icon--></span>        <div class="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">Заказы</div>
          <div class="font-weight-bold text-inverse-white font-size-sm">Всего заказов: {{quantity.orders}}</div>
        </div>
        <!--end::Body-->
      </router-link>
      <!--end::Stats Widget 16-->
    </div>
    <div class="col-xl-4">
      <!--begin::Stats Widget 17-->
      <router-link :to="{ name: 'Clients'}" class="card card-custom bg-info bg-hover-state-info card-stretch card-stretch gutter-b">
        <!--begin::Body-->
        <div class="card-body">
        <span class="svg-icon svg-icon-2x svg-icon-white"><!--begin::Svg Icon | path:assets/media/svg/icons/Communication/Group.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <polygon points="0 0 24 0 24 24 0 24"/>
        <path d="M18,14 C16.3431458,14 15,12.6568542
         15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8
          21,9.34314575 21,11 C21,12.6568542 19.6568542,14
           18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861
            6.790861,3 9,3 C11.209139,3 13,4.790861 13,7
             C13,9.209139 11.209139,11 9,11 Z" fill="#000000" fill-rule="nonzero" opacity="0.3"/>
        <path d="M17.6011961,15.0006174 C21.0077043,15.0378534
         23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056
          23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654
           18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055
            C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13
             17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741
              17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21
               0.727502227,21 C0.476712155,21 -0.0204617505,20.45918
                0.00065168429,20.1992055 Z" fill="#000000" fill-rule="nonzero"/>
    </g>
</svg><!--end::Svg Icon--></span>        <div class="text-inverse-info font-weight-bolder font-size-h5 mb-2 mt-5">Клиенты</div>
          <div class="font-weight-bold text-inverse-info font-size-sm">Всего зарегистрированых клиентов: {{quantity.clients}}</div>
        </div>
        <!--end::Body-->
      </router-link>
      <!--end::Stats Widget 17-->
    </div>
    <div class="col-xl-4">
      <!--begin::Stats Widget 18-->
      <router-link :to="{ name: 'Products'}" class="card card-custom bg-dark bg-hover-state-dark card-stretch gutter-b">
        <!--begin::Body-->
        <div class="card-body">
        <span class="svg-icon svg-icon-primary svg-icon-2x"><!--begin::Svg Icon | path:C:\wamp64\www\keenthemes\themes\metronic\theme\html\demo1\dist/../src/media/svg/icons\Shopping\Box2.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect x="0" y="0" width="24" height="24"/>
        <path d="M4,9.67471899 L10.880262,13.6470401
         C10.9543486,13.689814 11.0320333,13.7207107
          11.1111111,13.740321 L11.1111111,21.4444444
           L4.49070127,17.526473 C4.18655139,17.3464765
            4,17.0193034 4,16.6658832 L4,9.67471899
             Z M20,9.56911707 L20,16.6658832 C20,17.0193034
              19.8134486,17.3464765 19.5092987,17.526473
               L12.8888889,21.4444444 L12.8888889,13.6728275
                C12.9050191,13.6647696 12.9210067,13.6561758
                 12.9368301,13.6470401 L20,9.56911707 Z" fill="#000000"/>
        <path d="M4.21611835,7.74669402 C4.30015839,7.64056877
         4.40623188,7.55087574 4.5299008,7.48500698
          L11.5299008,3.75665466 C11.8237589,3.60013944
           12.1762411,3.60013944 12.4700992,3.75665466
            L19.4700992,7.48500698 C19.5654307,7.53578262
             19.6503066,7.60071528 19.7226939,7.67641889
              L12.0479413,12.1074394 C11.9974761,12.1365754
               11.9509488,12.1699127 11.9085461,12.2067543
                C11.8661433,12.1699127 11.819616,12.1365754
                 11.7691509,12.1074394 L4.21611835,7.74669402 Z" fill="#000000" opacity="0.3"/>
    </g>
</svg><!--end::Svg Icon--></span>       <div class="text-inverse-dark font-weight-bolder font-size-h5 mb-2 mt-5">Товары</div>
          <div class="font-weight-bold text-inverse-dark font-size-sm">Всего товаров: {{quantity.products}}</div>
        </div>
        <!--end::Body-->
      </router-link>
      <!--end::Stats Widget 18-->
    </div>
  </div>
  <!--end: List Widget 1-->
</template>

<script>

import { mapGetters } from "vuex";
import {GET_QUANTITY} from "../../../../core/services/store/dashboard.module";

export default {
  name: "widget-1",

  mounted() {
    this.$store.dispatch(GET_QUANTITY)
  },

  data() {
    return {

    };
  },
  computed: {
    ...mapGetters({
      layoutConfig: "layoutConfig",
      quantity: "gettersQuantity"
    })
  }
};
</script>
